import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  // No public nav items for admin/auth; admins use the private URL to access the dashboard

  return (
    <nav className="navbar">
      <div className="container">
        <div className="nav-container">
          <Link to="/" className="nav-logo">
            Compassion Course Foundation
          </Link>
          
          <button 
            className="nav-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            ☰
          </button>

          <ul className={`nav-menu ${isMenuOpen ? 'nav-menu-active' : ''}`}>
            <li><Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>Home</Link></li>
            <li><Link to="/about" className={`nav-link ${isActive('/about') ? 'active' : ''}`}>About</Link></li>
            <li><Link to="/programs" className={`nav-link ${isActive('/programs') ? 'active' : ''}`}>Programs</Link></li>
            <li><Link to="/events" className={`nav-link ${isActive('/events') ? 'active' : ''}`}>Events</Link></li>
            <li><Link to="/board" className={`nav-link ${isActive('/board') ? 'active' : ''}`}>Board</Link></li>
            <li><Link to="/blog" className={`nav-link ${isActive('/blog') ? 'active' : ''}`}>Blog</Link></li>
            <li><Link to="/contact" className={`nav-link ${isActive('/contact') ? 'active' : ''}`}>Contact Us</Link></li>
            <li><Link to="/donate" className="nav-link nav-donate">Donate</Link></li>
            {/* Admin and Logout links removed from public nav */}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
